import { Image, PromoModal } from '@cian/ui-kit';
import Cookies from 'js-cookie';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackOnboardingClick, trackOnboardingClose, trackOnboardingShow } from './tracking';
import { useOnboardingData } from './useOnboardingData';
import { setHideOnboardingByCookie } from '../../actions/cookies';
import { ONBOARDING_SEEN_COOKIE_NAME } from '../../constants/cookies';
import { TThunkDispatch } from '../../types/redux';

export function OnboardingContainer() {
  const onboardingData = useOnboardingData();

  const dispatch = useDispatch<TThunkDispatch>();

  const [isOpen, setIsOpen] = React.useState(true);
  const isOpenendRef = React.useRef(false);

  const closeReasonRef = React.useRef<'button' | 'cross' | 'other'>('other');

  const handleOpenChange = React.useCallback(
    (open: boolean) => {
      setIsOpen(open);
      if (!open && onboardingData) {
        trackOnboardingClose(onboardingData.id, closeReasonRef.current);
      }
      dispatch(setHideOnboardingByCookie());
    },
    [dispatch, onboardingData],
  );

  const handleSuccess = React.useCallback(() => {
    if (!onboardingData) {
      return;
    }

    trackOnboardingClick(onboardingData.id, onboardingData.textLink);
    setTimeout(() => window.open(onboardingData?.link), 500);
    setIsOpen(false);
  }, [onboardingData]);

  const handleReject = React.useCallback(() => {
    closeReasonRef.current = 'button';
    handleOpenChange(false);
  }, [handleOpenChange]);

  React.useEffect(() => {
    if (onboardingData && !isOpenendRef.current) {
      setIsOpen(true);
      trackOnboardingShow(onboardingData.id);
      Cookies.set(ONBOARDING_SEEN_COOKIE_NAME, '1', {
        domain: '.cian.ru',
        expires: 1,
      });
      isOpenendRef.current = true;
    }
  }, [onboardingData]);

  if (!onboardingData) {
    return null;
  }

  return (
    <PromoModal
      open={isOpen}
      onOpenChange={handleOpenChange}
      media={
        <Image src={onboardingData.image} objectFit="cover" width="100%" height="100%" alt={onboardingData.title} />
      }
      title={onboardingData.title}
      description={onboardingData.description}
      actionText={onboardingData.textLink}
      onPrimaryAction={handleSuccess}
      onSecondaryAction={handleReject}
      secondaryActionText={onboardingData.closeText}
    />
  );
}
